<template>
    <div class="container-fluid myWeeducEditVideo page-card text-left">
        <div class="position-relative">
            <h3 class="card-title">Editar Video</h3>
            <p class="card-subtitle">Edite as informações do seu vídeo</p>
            <button class="btn-delete" @click="deleteVideo">
                <fa icon="fa-trash" />
            </button>
        </div>

        <hr class="page-card__divider">

        <div class="contetContainerEditVideo" v-if="!isLoading && !isSaving">
            <div class="col-form-inner col-6 col-md-6 col-lg-6 freeVideo">
                <div class="col-form-inner col-12 col-md-12 col-lg-12">
                    <div class="form-group">
                        <div
                            class="itemAtionCollections form-check form-switch"
                        > 
                        <label class="labeld required" for="videoTitle"
                        >Status: <span class="status-label" :class="{ 'active': status, 'inactive': !status }">{{ status ? 'Ativo' : 'Inativo' }}</span></label>
                           
                            <input
                                class="form-check-input"
                                type="checkbox"
                                role="switch"
                                v-model="status"
                            />
                        </div>
                        <!-- <small>Ao ativar este vídeo, ele será disponibilizado ao público. Desative para ocultá-lo da visualização pública.</small> -->
                    </div>
                </div>

                <div class="mb-3 mb-md-4 text-left">
                    <label class="labeld required" for="videoTitle"
                        >Título do Video</label
                    >
                    <input
                        id="videoTitle"
                        type="text"
                        required
                        class="inputd"
                        v-model="videoData.title"
                        placeholder="Título do vídeo"
                    />
                </div>

                <div class="text-left">
                    <label class="labeld" for="videoDescription"
                        >Descrição</label
                    >
                    <textarea
                        id="videoDescription"
                        class="inputd"
                        v-model="videoData.description"
                        placeholder="Descreva o vídeo"
                        rows="4"
                    ></textarea>
                </div>
            </div>

            <div class="col-form-inner col-6 col-md-6 col-lg-6">
                <div class="preview-container">
                    <div class="video-preview" v-if="videoData.path">
                        <iframe
                            v-if="videoData.type == 2"
                            :src="getYoutubeEmbedUrl(videoData.path)"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen
                        ></iframe>
                        <iframe
                            v-if="videoData.type == 3"
                            :src="getVimeoEmbedUrl(videoData.path)"
                            frameborder="0"
                            allow="autoplay; fullscreen; picture-in-picture"
                            allowfullscreen
                        ></iframe>
                        <div v-if="videoData.type == 1" class="video-wrapper">
                            <iframe
                                :src="videoPlayer"
                                width="100%"
                                :height="heightPlayer"
                                frameborder="0"
                                allow="autoplay; fullscreen"
                                allowfullscreen
                            >
                                <img
                                    :src="videoData.finalVideoThumbnail"
                                    alt="Video Player"
                                />
                            </iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <Loader v-if="isLoading || isSaving" />

        <div class="actions">
            <v-btn variant="tonal" color="grey" size="large" @click="$router.go(-1)">Voltar</v-btn>
            <v-btn variant="flat" color="primary" size="large" @click="updateVideo">Salvar</v-btn>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import apiLesson from '@/utils/lesson';
    import Loader from '@/components/Loader/loader.vue';
    import playerVideo from '@/utils/storage/playerVideo';

    export default {
        name: 'EditVideo',
        components: {
            Loader,
        },
        data() {
            return {
                videoData: {
                    id: '',
                    type: 1,
                    title: '',
                    path: '',
                    description: '',
                    idModule: '',
                    idCourse: '',
                    status: 1,
                },
                status: true,
                isLoading: true,
                isSaving: false,
                videoPlayer: '',
                hasReady: false,
                heightPlayer: 600,
            };
        },
        computed: {
            ...mapState(['token']),
        },
        methods: {
            async loadLessonData() {
                const id = this.$route.params.slug;
                try {
                    const response = await apiLesson.getDataLessonById(
                        id,
                        this.token
                    );
                    this.videoData = response;
                    this.status = response.status === 1;
                    if (response.type == 1) {
                        this.getPlayerVideo();
                    }
                } catch (error) {
                    console.error('Erro ao carregar dados da lição:', error);
                } finally {
                    this.isLoading = false;
                }
            },
            getYoutubeEmbedUrl(url) {
                if (!url) return '';
                try {
                    const urlObj = new URL(url);
                    const videoId = urlObj.searchParams.get('v');

                    if (!videoId && urlObj.hostname.includes('youtu.be')) {
                        return `https://www.youtube.com/embed/${urlObj.pathname.slice(
                            1
                        )}`;
                    }

                    return videoId
                        ? `https://www.youtube.com/embed/${videoId}`
                        : '';
                } catch (error) {
                    console.error('URL inválida:', error);
                    return '';
                }
            },
            getVimeoEmbedUrl(url) {
                const videoId = url.split('/').pop();
                return videoId
                    ? `https://player.vimeo.com/video/${videoId}`
                    : '';
            },
            async updateVideo() {
                this.isSaving = true;

                const payload = {
                    type: this.videoData.type,
                    title: this.videoData.title,
                    path: this.videoData.path,
                    description: this.videoData.description,
                    idQuiz: null,
                    idModule: this.videoData.idModule,
                    idCourse: this.videoData.idCourse,
                    status: this.status ? 1 : 0,
                };

                try {
                    await apiLesson.editLesson(
                        this.token,
                        payload,
                        this.videoData.id
                    );
                    this.$router.push('/dashboard/curso');
                } catch (error) {
                    console.error('Erro ao atualizar vídeo:', error);
                    alert('Ocorreu um erro ao atualizar o vídeo');
                } finally {
                    this.isSaving = false;
                }
            },
            async deleteVideo() {
                if (confirm('Tem certeza que deseja excluir este vídeo?')) {
                    const id = this.$route.params.slug;
                    try {
                        await apiLesson.deleteLesson(id, this.token);
                        this.$router.push('/dashboard/curso');
                        alert('Vídeo excluído com sucesso!');
                    } catch (error) {
                        console.error('Erro ao excluir vídeo:', error);
                        alert('Ocorreu um erro ao excluir o vídeo');
                    }
                }
            },
            async getPlayerVideo() {
                const id = this.$route.params.slug;
                try {
                    const response = await playerVideo.getPlayerVideo(
                        this.token,
                        id
                    );
                    this.videoPlayer = response;
                    setTimeout(() => {
                        this.hasReady = true;
                    }, 2000);
                } catch (error) {
                    console.error('Erro ao obter o player:', error);
                }
            },
            verifyHeight() {
                const height = window.innerWidth;
                if (height < 450) {
                    this.heightPlayer = 300;
                } else {
                    this.heightPlayer = 600;
                }
            },
        },
        created() {
            this.verifyHeight();
            this.loadLessonData();
        },
    };
</script>

<style scoped>
    @import url(./global.css);

    .container {
        max-width: 100%;
        background-color: white;
        padding: 10px 0px;
        padding-bottom: 50px;
    }

    .titleContainer {
        display: block;
        text-align: left;
        padding: 0px 10px;
        border-bottom: 1px solid #e8e8e8;
        margin: 10px;
        position: relative;
    }

    .btn-delete {
        position: absolute;
        top: 0;
        right: 0;
        background-color: #fee7e7;
        padding: 5px 0px;
        color: #dc3545;
        border-radius: 5px;
        cursor: pointer;
        border: none;
    }

    .btn-delete svg {
        color: #dc3545 !important;
    }

    .contetContainerEditVideo {
        display: flex;
        flex-wrap: nowrap;
        align-items: flex-start;
        max-width: 100%;
        width: 100%;
        gap: 10px;
        padding-top: 20px;
    }

    .contetContainerEditVideo .col-form-inner.col-6.col-md-6.col-lg-6 {
        width: 49% !important;
    }
    .actions {
        display: flex;
        justify-content: flex-end;
        gap: 20px;
        margin-top: 30px;
        padding: 0px 20px;
    }

    .btn {
        padding: 8px 20px;
        border-radius: 5px;
        cursor: pointer;
        border: 1px solid #e8e8e8;
        background: white;
        color: #666;
    }

    .btn:last-child {
        background: #250891;
        color: white;
        border: none;
    }

    .form-group {
        margin-bottom: 20px;
    }

    .form-label {
        margin-bottom: 8px;
    }

    .form-control {
        width: 100%;
        padding: 8px;
        border: 1px solid #e8e8e8;
        border-radius: 5px;
    }

    .video-preview {
        width: 100%;
        aspect-ratio: 16/9;
        background: #f8f9fa;
        border-radius: 8px;
        overflow: hidden;
    }

    .video-preview iframe {
        width: 100%;
        height: 100%;
    }

    .video-wrapper {
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .container.myWeeducEditVideo .titleContainer {
        margin: 0;
        padding: 0;
        padding-bottom: 10px;
    }
    .myWeeducEditVideo .itemAtionCollections.form-check.form-switch {
        position: inherit;
        display: flex;
        gap: 10px;
        align-items: center;
        justify-content: space-between;
        padding: 10px 0px;
    }
    .myWeeducEditVideo .form-group .form-input textarea.form-control {
        height: 220px !important;
    }
    /* MEDIA */
    @media (max-width: 768px) {
        .contetContainerEditVideo {
            display: flex;
            flex-direction: column-reverse;
        }
        .contetContainerEditVideo .col-form-inner.col-6.col-md-6.col-lg-6 {
            width: 100% !important;
        }
    }
    .status-label {
        font-size: 14px;
        font-weight: 600;
        color: #666;
        padding: 5px 10px;
        border-radius: 5px;
    }
    .status-label.active {
        background-color: #2cb42c33;
        color: #7b7b7b;
        padding: 5px 10px;
        border-radius: 5px;
    }
    .status-label.inactive {
        background-color: #ff000033;
        color: #7b7b7b;
        padding: 5px 10px;
        border-radius: 5px;
    }
</style>
